module.exports = __webpack_public_path__ + "media/images/lb/324-9cb26cb6c53bdc4cf134bbcf54881339.svg";